export function passwordConfirmValidator(a: any, b: any): boolean {
    return !(typeof a === 'string' && typeof b === 'string' && a !== b);

}
